import React from 'react';
import HashLevel from './HashLevel.jsx';
import capitalize from 'capitalize';

export default class HashElement extends HashLevel {
  constructor(props) {
    super(props);
    this.state = this.props.data;
  }

  componentWillReceiveProps(props) {
    this.setState(props.data);
  }

  toggleActive() {
    let active = !this.state.active;

    if (active) {
      this.props.onElementClick(this.props.id);
    } else {
      this.updateState({ active: active });
      this.props.onUnselect();
    }
  }

  getTitle() {
    let name =
        this.state.key.default === '' ? 'Undefined' : this.state.key.default,
      valueType = this.state.value.types,
      type = valueType
        .map((t) => capitalize.words(t.replace(/_/g, ' ')))
        .join(', '),
      multiple = this.state.value.multiple ? '(Multiple)' : '';

    if (type === '') {
      type = 'Undefined';
    }
    if (this.state.key.mutable && name === 'Undefined') {
      name = 'Dynamic';
    }

    return `< ${name}: ${type} ${multiple} >`;
  }

  hasError() {
    if (
      typeof this.state.errors !== 'undefined' &&
      this.state.errors.length > 0
    ) {
      return true;
    }
    if (
      typeof this.state.key.errors !== 'undefined' &&
      this.state.key.errors.length > 0
    ) {
      return true;
    }
    if (
      typeof this.state.value.errors !== 'undefined' &&
      this.state.value.errors.length > 0
    ) {
      return true;
    }
    return false;
  }

  className() {
    return `${this.props.className} ${this.hasError() ? 'hasError' : ''} hashElementComponent`;
  }

  titleClassName() {
    let className = ['hashElementTitle'];

    if (this.state.active) {
      className.push('active');
    }
    if (this.state.required) {
      className.push('required');
    }
    return className.join(' ');
  }

  selfRemove() {
    if (this.state.active) {
      this.props.onUnselect();
    }
    this.props.remove(this.props.index);
  }

  render() {
    return (
      <div className={this.className()}>
        <div className='treeLevelItem hashElement'>
          <a
            className={this.titleClassName()}
            onClick={this.toggleActive.bind(this)}
          >
            {this.getTitle()}
          </a>
          <a
            className='ui icon red button hide-disabled'
            onClick={this.selfRemove.bind(this)}
          >
            <i className='icon minus'></i>
          </a>
        </div>
        <div
          className={
            this.state.children.length > 0
              ? 'treeLevel withChildren children_' + this.state.children.length
              : 'treeLevel'
          }
        >
          {this.state.children.map((child, index) => {
            return (
              <HashElement
                key={index}
                ref={child.id}
                className={this.childClass(index, this.state.children.length)}
                data={child}
                id={child.id}
                index={index}
                remove={this.remove.bind(this)}
                onChange={this.onElementUpdate.bind(this)}
                onElementClick={this.props.onElementClick}
                onUnselect={this.props.onUnselect}
              />
            );
          })}
          <If condition={this.state.value.types.indexOf('hash') > -1}>
            <div className='treeLevelItem button-element'>
              <a
                className='ui icon button green'
                onClick={this.addChildren.bind(this)}
              >
                <i className='icon plus'></i>
              </a>
            </div>
          </If>
        </div>
      </div>
    );
  }
}
